import { Outlet, useLocation } from 'react-router-dom';
import ErrorBoundary from 'components/ErrorBoundary';
import UserRoutesLayout from './UserRoutesLayout';
import GuestRoutesLayout from './GuestRoutesLayout';

function LayoutWrapper({ isAuthenticated }) {
  const { pathname } = useLocation();
  if (isAuthenticated) {
    return (
      <UserRoutesLayout>
        <ErrorBoundary resetKey={pathname}>
          <Outlet />
        </ErrorBoundary>
      </UserRoutesLayout>
    );
  }
  return (
    <GuestRoutesLayout>
      <ErrorBoundary resetKey={pathname}>
        <Outlet />
      </ErrorBoundary>
    </GuestRoutesLayout>
  );
}

export default LayoutWrapper;
